import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CONFIGCONSTANTS } from '../config/app-constants';
import { ManageuserService } from '../_services/manageuser-service';

// Sr.NO HTML

// <ngx-datatable-column
//   name="{{ 'SR_NO' | translate }}"
//   headerClass="no-sorting text-center"
//   prop="srNum"
//   [sortable]="false"
//   [width]="70"
// >
//   <ng-template let-value="value" ngx-datatable-cell-template>
//     <div class="text-center">{{ value }}</div>
//   </ng-template>
// </ngx-datatable-column>

// modal footer
// <div class="modal-footer">
// <button type="button" class="btn btn-warning" (click)="decline()">
//   {{ "CLOSE" | translate }}
// </button>
// </div>
@Component({
  selector: 'app-connection-list',
  template: `
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title">
          <i class="fa fa-user modal-icon"></i>
          {{modalTitle}}
        </h5>
        <button type="button" class="close" (click)="decline()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group show-select">
              <label
                >{{ "SHOW" | translate }}
                <select
                  name="showRecords"
                  [(ngModel)]="size"
                  (change)="changeLimit(size)"
                  class="form-control"
                >
                  <option [value]="limit" *ngFor="let limit of limitList">{{
                    limit
                  }}</option>
                </select>
                {{ "ENTRIES" | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="wrap-datatable pos-rel">
        <div *ngIf="loadingIndicator" class="processing">Processing...</div>
              <ngx-datatable
                [rows]="userList"
                class="material fullscreen"
                headerHeight="headerHeight"
                footerHeight="footerHeight"
                rowHeight="rowHeight"
                [reorderable]="reorderable"
                [columnMode]="ColumnMode.force"
                #datatable
                [scrollbarH]="scrollbarH"
                [externalSorting]="serverSorting"
                (sort)="onSort($event)"
                [sorts]="[{ prop: sortParam, dir: sortOrder }]"
                [externalPaging]="serverPaging"
                [count]="totalReords"
                [offset]="pageNumber"
                [limit]="size"
                (page)="setPage($event)"
                [messages]="dtMessages"
              >
                <ngx-datatable-column name="{{ 'NAME' | translate }}" [minWidth]="70" prop="first_name" [sortable]="false">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  {{ row.first_name}} {{row.last_name}}
                </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column *ngIf="type=='Patient' && moduleType!='PATIENT'" name="{{ 'AGE' | translate }}" prop="age" [sortable]="false">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div class="text-center">{{ value || '-'}}</div>
                </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column *ngIf="type=='Patient'" [maxWidth]="100" name="{{ 'GENDER' | translate }}" prop="gender" [sortable]="false"></ngx-datatable-column>
                <ngx-datatable-column *ngIf="type=='Doctor' && moduleType!='DOCTOR'" name="{{ 'SPECIALIZATION_TITLE' | translate }}" prop="title" [sortable]="false">
                </ngx-datatable-column>
                <ngx-datatable-column *ngIf="type=='Doctor' && moduleType!='DOCTOR'" name="{{ 'QUALIFICATIONS' | translate }}" prop="doctor_qualiftn" [sortable]="false">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <div class="text-center">{{ value || '-'}}</div>
                </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{ 'LOCATION' | translate }}" prop="address" prop="clinic_address" prop="flat_number"  [sortable]="false">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="text-center" *ngIf="row.clinic_address">
                {{row.clinic_address}}
              </div>
              <div class="text-center" *ngIf="!row.clinic_address">
                             <span
                      *ngIf="(( row.address !='null' && row.address != undefined && row.address != '') && (
                      row.flat_number == 'null' || row.flat_number == undefined || row.flat_number == '') )">{{row.address}}</span>
                    <span *ngIf="(( row.flat_number != 'null' && row.flat_number != undefined && row.flat_number != '') && (
                      row.address =='null' || row.address == undefined || row.address == '') )">{{row.flat_number}}
                    </span>
                    <span *ngIf="((row.address !=null && row.address!= undefined && row.address != '') && ( row.flat_number
                      != 'null' && row.flat_number != undefined && row.flat_number != ''))
                      ">{{row.flat_number}},{{row.address}}</span>
              </div>
                </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ConnectionListComponent implements OnInit {
  id: any;
  modalTitle: string;
  type: string;
  moduleType: string;
  userList: any[] = [];
  // Get datatble configuration -- start
  loadingIndicator = false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = CONFIGCONSTANTS.datatableConfig.serverPaging;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  size = CONFIGCONSTANTS.datatableConfig.page.size;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;
  sortParam = '';
  sortOrder = '';
  // Get datatble configuration -- end

  name = '';
  constructor(
    private manageuserService: ManageuserService,
    public modalRef: BsModalRef,
    private modalService: BsModalService) {
    
  }
  ngOnInit() {
    this.getConnectionList();
  }
  /**
   * Sort datatable fields
   * @param event event was triggered, start sort sequence 
   */
  public onSort(event) {
    this.sortParam = event.sorts[0].prop;
    this.sortOrder = event.sorts[0].dir;
    this.rerender(false);
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  public setPage(pageInfo) {
    this.pageNumber = pageInfo.offset;
    this.rerender(false);
  }
  /**
   * Show number of records in datatable
   * @param value show total entries value 10,25,50,100
   */
  public changeLimit(value) {
    this.size = value;
    this.rerender(true);
  }
  /**
   * API call and refresh datatable value
   * @param goFirstPage set first page when param value true
   */
  private rerender(goFirstPage): void {
    if (goFirstPage) {
      this.pageNumber = 0;
    }
    this.getConnectionList();
  }
  getConnectionList() {
    this.loadingIndicator = true;
    this.manageuserService.getConnectionList({
      start: (this.pageNumber) * (this.size),
      length: this.size,
      user_type: this.type
      // sort_param: this.sortParam,
      // sort_type: this.sortOrder
    } , this.id)
      .pipe(first())
      .subscribe(resp => {
        this.loadingIndicator = false;
        const respData = resp.data['original'];
        this.userList = respData.data;
        console.log(this.userList);
        this.totalReords = respData.recordsTotal;
      }, error => {
        this.loadingIndicator = false;
      });
  }
  decline(): void {
    this.modalRef.hide();
  }

    }
    
